import { render } from "./SearchBuildingModule.vue?vue&type=template&id=34b02369"
import script from "./SearchBuildingModule.vue?vue&type=script&lang=js"
export * from "./SearchBuildingModule.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__